import React from "react";

const CreateClassworkout = React.lazy(() => import("./CreateClassworkout"));

export const classWorkoutRoutes = [
  {
    path: "/admin/classWorkout/create",
    name: "Create Class Workouts",
    element: <CreateClassworkout />,
  },
  {
    path: "/admin/classWorkout/update/:id",
    name: "Create Class Workouts",
    element: <CreateClassworkout />,
  },
];
